import { cn } from "@/lib/utils";

/** Five wavy series, one per stop, in a 200×64 box. */
const SERIES = [
  "0,22 25,16 50,24 75,12 100,18 125,10 150,15 175,8 200,12",
  "0,32 25,30 50,26 75,32 100,24 125,28 150,22 175,26 200,20",
  "0,40 25,36 50,42 75,38 100,44 125,36 150,40 175,34 200,38",
  "0,48 25,50 50,46 75,52 100,48 125,52 150,46 175,50 200,44",
  "0,58 25,54 50,58 75,55 100,59 125,54 150,57 175,52 200,55",
];

/** Gridlines at a quarter, half and three-quarters of the height. */
const GRID_Y = [16, 32, 48];

/**
 * A miniature line chart for a Preferences choice: five series in `colors`
 * (any CSS colour, `var(--…)` included) over gridlines in `grid`, drawn at
 * the line weight `weightClass` sets — or, without one, the page's own.
 * Strokes are in CSS pixels (`non-scaling-stroke`), so they match the real
 * charts' widths however wide the tile is.
 *
 * Decorative: hidden from assistive tech, the tile around it names the choice.
 */
export function ChartPreview({
  colors,
  grid = "var(--border)",
  weightClass,
}: {
  colors: readonly string[];
  grid?: string;
  weightClass?: string;
}) {
  return (
    <div aria-hidden className={cn(weightClass, "pointer-events-none bg-card px-2 py-2.5")}>
      <svg viewBox="0 0 200 64" preserveAspectRatio="none" className="h-20 w-full">
        {GRID_Y.map((y) => (
          <line
            key={y}
            x1={0}
            x2={200}
            y1={y}
            y2={y}
            vectorEffect="non-scaling-stroke"
            style={{ stroke: grid, strokeWidth: "1px" }}
          />
        ))}
        {SERIES.map((points, i) => (
          <polyline
            key={points}
            points={points}
            fill="none"
            vectorEffect="non-scaling-stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              stroke: colors[i % colors.length],
              strokeWidth: "calc(1.5px * var(--chart-line-scale, 1))",
            }}
          />
        ))}
      </svg>
    </div>
  );
}
